import Left from './Left';
import Right from './Right';
import { Header } from './styled';
import { GlobalHeaderProps } from './types';

const GlobalHeader = ({
  logoStyle = 'icon',
  page,
  breadcrumbs,
  title,
  sx = {},
}: GlobalHeaderProps) => {
  return (
    <>
      <Header sx={sx}>
        {title || <Left logoStyle={logoStyle} breadcrumbs={breadcrumbs} page={page} />}
        <Right />
      </Header>
    </>
  );
};

export default GlobalHeader;
